import React from "react";

const CardComponent = () => {
  return (
    <div className="map-card">
      <div class="card-header">
        <div class="instructions-btn">instructions</div>
        <div class="close-btn" onclick="closeCard()">
          &times;
        </div>
      </div>
      <div class="titleofthemap">
        <p>
          <strong>AGENCE SUNU ASSURANCES SAN PEDRO</strong>
        </p>
      </div>
      <div class="card-content">
        <div class="infos-line">
          <i class="fa-solid fa-location-dot"></i>
          <p>Bp 335 Bd de la République Quartier cité San Pedro</p>
        </div>

        <div class="infos-line">
          <a href="/">
            <i class="fa-solid fa-earth-africa"></i>
            <p>bicici.ci</p>
          </a>
        </div>

        <div class="infos-line">
          <i class="fa-solid fa-phone"></i>
          <p>27 20 24 24 24</p>
        </div>
      </div>
      <div class="card-footer">
        <p>Agence Ouverte : 08H00</p>
        <p>Agence Fermée : 16H30</p>
        <p>Lundi au vendredi : 09H00 - 12H00</p>
        <p>Horaire Samedi : 09H00 - 12H00</p>
      </div>
    </div>
  );
};

export default CardComponent;
